import {createApp} from 'vue';
import './style.css';
import App from './App.vue';

import router from "./router";
import store from "./store";

import './style/index.less';
import './style/comman.less';
import './style/variables.less';

import 'vant/lib/index.css';
import './style/quill.core.css';
import './style/quill.snow.css';

const app = createApp(App);
app.use(router);
app.use(store);
app.mount('#app');
